"use strict";
const { STRING, NUMBER, DATE, ARRAY_OF_STRING, } = require('../operandValueTypes');
const { CONSTANT } = require('../operandTypes');
exports.generateConstant = ({ value, valueType, context }) => {
    const constant = {
        type: CONSTANT,
        value,
        valueType,
        context,
    };
    /** Context object is only used by operands with more than one value.
     *  We can safely delete context if it is undefined.
     */
    Object.keys(constant).forEach((key) => constant[key] === undefined && delete constant[key]);
    return constant;
};
exports.generateStringConstant = ({ value }) => exports.generateConstant({
    value,
    valueType: STRING,
});
exports.generateArrayOfStringConstant = ({ value }) => exports.generateConstant({
    value,
    valueType: ARRAY_OF_STRING,
});
exports.generateNumberConstant = ({ value }) => exports.generateConstant({
    value,
    valueType: NUMBER,
});
exports.generateNumberBetweenConstant = ({ greaterThanValue, lessThanValue }) => exports.generateConstant(Object.assign(Object.assign({}, exports.generateNumberConstant({ value: greaterThanValue })), { context: {
        lessThan: exports.generateNumberConstant({ value: lessThanValue }),
    } }));
exports.generateDateConstant = ({ value }) => exports.generateConstant({
    value,
    valueType: DATE,
});
exports.generateDateRangeConstant = ({ durationValue, durationUnit }) => exports.generateConstant(Object.assign(Object.assign({}, exports.generateNumberConstant({ value: durationValue })), { context: {
        durationUnit,
    } }));
exports.generateDateBetweenConstant = ({ afterValue, beforeValue }) => exports.generateConstant(Object.assign(Object.assign({}, exports.generateDateConstant({ value: afterValue })), { context: {
        before: exports.generateDateConstant({ value: beforeValue }),
    } }));
//# sourceMappingURL=constantFactory.js.map